__turbopack_context__.v({
  "buttonWrapper": "_0nX3Ha_buttonWrapper",
  "first": "_0nX3Ha_first",
  "last": "_0nX3Ha_last",
  "light": "_0nX3Ha_light",
  "statFlex": "_0nX3Ha_statFlex",
});
